// extracted by mini-css-extract-plugin
export var actions = "_4f-0";
export var actionsContainer = "_4f-8";
export var border = "_4f-1";
export var childFullHeight = "_4f-f";
export var collapse = "_4f-2";
export var content = "_4f-a";
export var contentChild = "_4f-e";
export var fullscreen = "_4f-c";
export var hasLeftRadius = "_4f-r";
export var headerContainer = "_4f-3";
export var headerRow = "_4f-5";
export var hidePadding = "_4f-b";
export var navCollapsedGap = "_4f-s";
export var noScrollX = "_4f-t";
export var noScrollY = "_4f-u";
export var noTopPadding = "_4f-p";
export var optOutTopPadding = "_4f-d";
export var outletContent = "_4f-l";
export var outletContentInner = "_4f-m";
export var outletLeadingPanel = "_4f-i";
export var outletLeadingPanelAttention = "_4f-j";
export var outletNoScroll = "_4f-7";
export var outletResizeDivider = "_4f-k";
export var outletSplit = "_4f-g";
export var outletSplitResizing = "_4f-h";
export var pageMain = "_4f-q";
export var pageOuter = "_4f-n";
export var pagePadding = "_4f-9";
export var profile = "_4f-v";
export var profileContainer = "_4f-w";
export var profileImage = "_4f-x";
export var profileMain = "_4f-y";
export var profileSubtitle = "_4f-10";
export var profileTitle = "_4f-z";
export var showLeftPadding = "_4f-o";
export var tabsPortalSlot = "_4f-6";
export var tabsWrapper = "_4f-4";
export var title = "_4f-11";